import axios from 'axios';

import { Resolve } from './';
import config from './config';

interface IEventSettings {
  id: number;
  live_interactions: boolean;
}

const url = process.env.VUE_APP_SERVER_PATH;

export interface IClientAccount {
  client_name: string;
  client_email: string;
}

export interface ISignupClientAccount {
  name: string;
  email: string;
  password: string;
  emails_opt_in: boolean;
}

export const getClientAccounts = () => new Promise((resolve: Resolve<any[]>, reject) => {
  axios
    .get(`${url}/v2/client-accounts`, config())
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err);
    });
});

export const addClient = (client_data: IClientAccount) => new Promise((resolve: Resolve<any[]>, reject) => {
  axios
    .post(`${url}/v2/client-accounts`, client_data, config())
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err);
    });
});

export const signupClient = (client_data: ISignupClientAccount) => new Promise((resolve: Resolve<any[]>, reject) => {
  axios
    .post(`${url}/v2/accounts-signup`, client_data, config())
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err);
    });
});

